import React from 'react'
import "../Product/Intro.css";  
import { useLanguage } from "../LanguageContext";  

const SoftwareProducts = () => {
    const { language } = useLanguage();
  
  return (
    <div className="hardware-container">
      <div className="content">
        <h2 className="heading"><span>Software Products</span></h2>
        <p className="description">
          {language === "en" ? (
            <>
              Proscope offers a wide range of software solutions from leading
              global providers and emerging tech vendors. Our portfolio includes{" "}
              <strong>enterprise-grade software</strong>,{" "}
              <strong>commercial applications</strong>, and{" "}
              <strong>consumer tools—</strong>carefully selected to meet diverse
              business needs across all sectors.
              <br />
              <br />
            </>
          ) : (
            <>
              <strong>Proscope </strong>
              นำเสนอซอฟต์แวร์หลากหลายประเภทจากผู้พัฒนาและผู้ผลิตชั้นนำทั้งในระดับสากลและกลุ่มเทคโนโลยีเฉพาะทาง
              ครอบคลุมทั้งซอฟต์แวร์สำหรับองค์กร{" "}
              <strong> (Enterprise Software), </strong>
              ซอฟต์แวร์เชิงพาณิชย์<strong> (Commercial Software) </strong>
              และซอฟต์แวร์สำหรับผู้ใช้ทั่วไป
              <strong> (Consumer Software) </strong>
              <br />
              <br />
            </>
          )}
        </p>

        <p className="description">
          {language === "en" ? (
            <>
              We provide solutions in areas such as{" "}
              <strong>collaboration</strong>, <strong>cybersecurity</strong>,{" "}
              <strong>data analytics</strong>,{" "}
              <strong>system management</strong>, and{" "}
              <strong>application development</strong>. Our certified
              engineering and consulting team supports every step—from selection
              and licensing to deployment, training, and integration.
              <br />
              Additionally, we offer expert consultation on{" "}
              <strong>proper software licensing</strong> to ensure your
              organization complies with legal and industry standards.
            </>
          ) : (
            <>
              เราคัดสรรโซลูชันที่ตอบโจทย์ทั้งด้าน
              <strong>
                {" "}
                การทำงานร่วมกัน, ความปลอดภัย, การวิเคราะห์ข้อมูล,
                การบริหารจัดการระบบ และ การพัฒนาแอปพลิเคชัน{" "}
              </strong>
              พร้อมบริการจากทีมวิศวกรและที่ปรึกษาของเราที่จะดูแลคุณตั้งแต่การเลือกใช้
              ไปจนถึงการติดตั้งและฝึกอบรม
              <br />
              นอกจากนี้ เรายังให้คำปรึกษาเกี่ยวกับการจัดการ
              <strong> ลิขสิทธิ์ซอฟต์แวร์ที่ถูกต้อง </strong>
              เพื่อให้คุณมั่นใจว่าองค์กรดำเนินการตามกฎหมายและมาตรฐานที่เกี่ยวข้องอย่างครบถ้วน
            </>
          )}
        </p>
        <p className="description">
          {language === "en" ? (
            <>
            <br />
              If you’re looking for a specific software or brand not listed
              here, please don’t hesitate to contact us.{" "}
              <br />
              <strong>
                We’ll be happy to help you find the right solution for your
                business.
              </strong>
            </>
          ) : (
            <>
            <br />
              หากคุณไม่พบซอฟต์แวร์หรือแบรนด์ที่ต้องการ กรุณาติดต่อเรา —
              <br />
              <strong>
                เรายินดีช่วยแนะนำและจัดหาโซลูชันที่เหมาะสมกับความต้องการของคุณ
              </strong>
            </>
          )}
        </p>
        <div className="horizontal-text-container">
          <p>Products</p>
          <p>/</p>
          <p>Software Products</p>
        </div>
      </div>
    </div>
  );
};

export default SoftwareProducts;

